/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'
import { Form, Field } from 'formik'
import { Anchor, Button, Theme } from '@nexigendigital/nxui'

import { WEIGHT } from 'helpers/constants'

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
export const Login = {
    Form: styled(Form)`
        position: relative;
        width: 100%;
        height: 100%;

        label {
            width: 100%;
        }
    `,
    Body: styled.div`
        padding: 20px 20px 5px;
    `,
    Checkbox: styled.div`
        margin-top: 10px;
    `,
    Footer: styled.div`
        position: relative;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        height: auto;
        background: ${props => (props.theme['background--100'])};
        border-radius: 0 0 16px 16px;
    `
}

export const ResetPassword = {
    Form: styled(Form)`
        position: relative;
    `,
    Container: styled.div`
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `,
    Body: styled.div`
        padding: 0 20px 15px;
    `,
    Footer: styled.div`
        display: flex;
        flex-drection: row;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 20px;
        height: auto;
        background: ${props => (props.theme['background--100'])};
        border-radius: 0 0 16px 16px;

        > div {
            display: flex;
        }
    `
}

export const TwoFactorSelect = {
    Container: styled.div`
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
    `,
    Form: styled(Form)`
        width: 100%;
        border-radius: 15px;
    `,
    Loader: styled.div`
        display: flex;
        align-item: center;
        justify-content: center;
        width: 100%
        height: 100%;
        padding: 10px 20px 20px;
    `,
    Body: styled.div`
        padding: 0 20px 20px;
    `,
    Footer: styled.div`
        display: flex;
        flex-drection: row;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        height: auto;
        background: ${props => (props.theme['background--100'])};
        border-radius: 0 0 16px 16px;

        > div {
            display: flex;
        }
    `
}

export const SelectAccount = {
    Container: styled.div`
         position: relative;
         width: 100%;
         height: 100%;
         display: flex;
         justify-content: center;
         align-items: center;
         flex-direction: column;
         padding: 0 20px 15px;
 
         > button {
             width: 100%;
         }
     `,
    Footer: styled.div`
         position: relative;
         bottom: 0;
         display: flex;
         flex-direction: row;
         justify-content: flex-end;
         align-items: center;
         padding: 10px 20px;
         height: auto;
         background: ${props => (props.theme['background--100'])};
         border-radius: 0 0 16px 16px;
     `
}

export const TwoFactorRecovery = {
    Container: styled.div`
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 20px 15px;
    `,
    Loader: styled.div`
        padding: 10px 20px 20px;
    `,
    Label: styled.div`
        > p {
            color: ${props => (props.theme['text--100'])};
            padding-top: 5px;
        };
    `,
    Footer: styled.div`
        display: flex;
        justify-content: flex-end;
        padding: 10px 20px;
        height: auto;
        width: 100%;
        background: ${props => (props.theme['background--100'])};
        border-radius: 0 0 16px 16px;
    `,
    Anchor: styled(Anchor)`
        display: inline-flex;
        align-items: center;
        justify-content: center;
        height: 38px;
        width: 100%;
        margin: 4px;
        padding: 0.5rem 1rem;
        color: ${props => (props.theme['text--300'])};
        font-size: 14px;
        letter-spacing: -0.25px;
        line-height: 2;
        background-color: ${props => (props.theme['white--100'])};
        border-radius: 0.375rem;
        border: 1px solid ${props => (props.theme['gray--200'])};
        ${Theme.Functions.animation('transition-all')};
        ${Theme.Functions.setFont('Inter', WEIGHT.SEMI_BOLD)};

        &:hover {
            background-color: ${props => (props.theme['background--200'])};
        };
    `,
    Button: styled(Button)`
        width: 100%;
    `
}

export const Recovery = {
    Default: {
        Header: {
            Container: styled.div`
                position: relative;
                display: flex;
                flex-direction: column;
                width: 100%;
                padding: 20px 20px 0;
                ${Theme.Functions.setFont('Inter', WEIGHT.MEDIUM)};
            `,
            Title: styled.span`
                color: ${props => (props.theme['text--300'])};
                font-size: 18px;
                margin-bottom: 5px;
                ${Theme.Functions.setFont('Inter', WEIGHT.MEDIUM)};
            `,
            Description: styled.span`
                color: ${props => (props.theme['text--100'])};
                font-size: 14px;
                ${Theme.Functions.setFont('Inter', WEIGHT.REGULAR)};
            `
        },
        Container: styled.div`
            width: 100%;
            padding: 20px;
        `
    },
    CTA: {
        Header: {
            Container: styled.div`
                position: relative;
                display: flex;
                justify-content: center;
                flex-direction: column;
                width: 100%;
                padding: 20px 20px 0;
                text-align: center;
                ${Theme.Functions.setFont('Inter', WEIGHT.MEDIUM)};
            `,
            Icon: styled.div`
                display: flex;
                align-items: center;
                justify-content: center;
                flex-shrink: 0;
                height: 2.5rem;
                width: 2.5rem;
                margin: 0 auto;
                border-radius: 9999px;
                color: ${props => (props.theme['confirm--100'])};
                background-color: ${props => (Theme.Functions.hexToRGBA(props.theme['confirm--100'], '0.15'))};
        
                ${props => Theme.Functions.mediaBreakUp(props.theme['breakpoints-sm'])} {
                    height: 3.25rem;
                    width: 3.25rem;
                    margin: 0 auto 1rem;
                };
            `,
            Title: styled.span`
                color: ${props => (props.theme['text--300'])};
                font-size: 18px;
                margin-bottom: 5px;
                ${Theme.Functions.setFont('Inter', WEIGHT.MEDIUM)};
            `,
            Description: styled.span`
                color: ${props => (props.theme['text--100'])};
                font-size: 14px;
                ${Theme.Functions.setFont('Inter', WEIGHT.REGULAR)};

                strong {
                    color: ${props => (props.theme['text--300'])};
                    ${Theme.Functions.setFont('Inter', WEIGHT.MEDIUM)};
                }
            `
        },
        Container: styled.div`
            width: 100%;
            padding: 20px 20px;
        `,
        Footer: styled.div`
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            padding: 10px 20px;
            height: 68px;
            background: ${props => (props.theme['background--100'])};
            border-radius: 0 0 16px 16px;
        `,
        Anchor: styled(Anchor)`
            margin: 0 auto;
            font-size: 14px;
            letter-spacing: -0.25px;
            ${Theme.Functions.setFont('Inter', WEIGHT.MEDIUM)};
        `
    },
    Container: styled.div`
        width: 100%;
        padding: 20px;
    `,
    Footer: styled.div`
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        padding: 10px 20px;
        height: 68px;
        background: ${props => (props.theme['background--100'])};
        border-radius: 0 0 16px 16px;
    `,
    Form: {
        Input: styled(Field)`
            width: 100%;
        `
    },
    Button: styled(Button)`
        display: block;
        margin: 0 auto;
    `,
    Anchor: styled(Anchor)`
        margin: 0 auto;
    `
}

export const Registration = {
    Form: styled.div``,
    Body: styled.div``,
    Checkbox: styled.div``,
    Footer: styled.footer``
}
